module.exports = __webpack_public_path__ + "static/media/答疑二@2x.4556ec90.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_171/images/答疑二@2x.png
// module id = 1555
// module chunks = 0